import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const BASE_URL = process.env.REACT_APP_BASE_URL;

const useIndustryPaymentStatus = (isIndustryApproved) => {
  const [isIndustryPaymentStatus, setIsIndustryPaymentStatus] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (!isIndustryApproved) return; 

    const fetchPaymentStatus = async () => {
      try {
        const res = await fetch(`${BASE_URL}/marketplace/industry/payment-status`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
            "Content-Type": "application/json",
            "x-api-key": process.env.REACT_APP_X_API_KEY,
          },
        });
        const data = await res.json();
        // console.log("The payment status is:",data)
        if (data?.paid === false) {
          navigate("/marketplace/industry/payment");
          setIsIndustryPaymentStatus(false)
        }
        else{
           setIsIndustryPaymentStatus(true)
        }
      } catch (err) {
        console.error(err);
        navigate("/marketplace/industry");
      }
    };

    fetchPaymentStatus();
  }, [navigate, isIndustryApproved]);

  return isIndustryPaymentStatus ;
};

export default useIndustryPaymentStatus;